import React, { ReactNode } from 'react';
import Alert from '@mui/material/Alert';
import { BhiDialog, DialogProps } from './Dialog';
import { FormContent, FormActions } from './BhiFormDialog.styles';

export type BhiFormDialogProps = DialogProps & {
  actions: ReactNode;
  error?: ReactNode;
  compactSpacing?: boolean;
};

export const BhiFormDialog = ({ children, actions, error, compactSpacing, ...props }: BhiFormDialogProps) => (
  <BhiDialog fullWidth maxWidth="sm" {...props}>
    <FormContent $compactSpacing={compactSpacing}>
      {children}
      {error && <Alert severity="error">{error}</Alert>}
    </FormContent>
    <FormActions disableSpacing>{actions}</FormActions>
  </BhiDialog>
);
